import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { BuildForm } from 'src/app/shared/models/formulir/build-form.model';
import { DetailBuildForm } from 'src/app/shared/models/formulir/detail-build-form.model';
import { Adapter } from '../adapter.service';

@Injectable({
  providedIn: 'root',
})
export class BuildFormAdapter implements Adapter<BuildForm> {
  public adapt(item: any): BuildForm {
    return {
      id: item.idBuildForm,
      namaForm: item.namaForm || item.nama,
      namaTable: item.namaTable,
      dateMake: moment(item.dateMake).toDate(),
      type: item.type,
      idGroupBuildForm: item.idGroupBuildForm,
      instalasi: { id: item.idInstallasi, nama: item.namaInstallasi },
      ruang: item.idRuang && item.namaRuang ? { id: item.idRuang, nama: item.namaRuang } : null,
      navigation: { head: item.navigationHead, child: item.navigationChild || null },
      target: Number(item.target),
      statusAntrianMedis: item.statusAntrianMedis === 1,
      useMongodb: item.useMongodb,
      idKategoriKaryawan: item.idKategoriKaryawan ? item.idKategoriKaryawan.split(',') : [],
      details: item.details
        ? item.details.map((det: any) => {
            let parseAttributeData = null;
            try {
              if (det.attributeData) {
                parseAttributeData = JSON.parse(det.attributeData);
              }
            } catch (err) {}
            return {
              id: det.idDetailBuildForm,
              name: det.name,
              nameAttribute: det.nameAttribute,
              attributeData: parseAttributeData,
              dateMake: det.dateMake ? moment(det.dateMake).toDate() : null,
              inputType: det.inputType,
            } as DetailBuildForm;
          })
        : undefined,
    };
  }
}
